/* Scoop Your Own Box. Markup in sections/scoop-box-builder.liquid, data from
   /collections/all?view=box-data (templates/collection.box-data.liquid). */
(function () {
  'use strict';
  var root = document.getElementById('sbb');
  if (!root) return;

  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  var cfg = {
    feed: root.dataset.feed,
    giftId: +root.dataset.giftId,
    giftPrice: +root.dataset.giftPrice || 590,
    min: +root.dataset.min || 5000,
    cart: root.dataset.cart || '/cart',
    cartAdd: root.dataset.cartAdd || '/cart/add.js'
  };
  var KEY = 'sbb-draft-v1', CACHE = 'sbb-feed-v1', PAGE = 48;
  var S = { products: [], by: {}, items: [], boxes: 1, q: '', type: '', diet: '', fav: false, shown: PAGE, favs: {}, ready: false, lastAdded: null };
  var starters = [];
  try { starters = JSON.parse(document.getElementById('sbb-starters').textContent || '[]'); } catch (e) { starters = []; }

  /* ---------- helpers ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) { return '$' + (Math.round(c) / 100).toFixed(2); }
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) { return null; } }
  function sstore(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  var toastT;
  function toast(msg) { var t = $('[data-sbb-toast]'); t.textContent = msg; t.classList.add('is-on'); clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('is-on'); }, 2400); }
  function fmtG(g) { return g >= 1000 ? (g / 1000).toFixed(g % 1000 ? 1 : 0).replace('.0', '') + ' kg' : g + ' g'; }
  function initials(n) { return String(n || '?').split(/\s+/).slice(0, 2).map(function (w) { return w.charAt(0); }).join('').toUpperCase(); }

  /* ---------- product model ---------- */
  function prep(p) {
    p.v = p.v || [];
    p.v100 = null; p.vkg = null;
    p.v.forEach(function (v) {
      var t = norm(v.t).replace(/\s+/g, '');
      if (t === '100g') p.v100 = v;
      if (t === '1kg') p.vkg = v;
    });
    p.bulk = !!p.v100;
    p.s = norm(p.n + ' ' + (p.ty || '') + ' ' + (p.c || '') + ' ' + (p.d || []).join(' '));
    return p;
  }
  function itemKey(it) { return it.h + (it.vid ? '|' + it.vid : ''); }
  function price(it) {
    var p = S.by[it.h]; if (!p) return 0;
    if (p.bulk) {
      var kg = p.vkg ? Math.floor(it.amt / 1000) : 0;
      var rest = Math.round((it.amt - kg * 1000) / 100);
      return kg * (p.vkg ? p.vkg.p : 0) + rest * p.v100.p;
    }
    var v = variant(p, it.vid);
    return v ? v.p * it.amt : 0;
  }
  function variant(p, vid) { for (var i = 0; i < p.v.length; i++) if (p.v[i].id === vid) return p.v[i]; return p.v[0]; }
  function amtLabel(it) {
    var p = S.by[it.h];
    if (p.bulk) return money(p.v100.p) + ' / 100 g';
    var v = variant(p, it.vid);
    var vt = v && !/default title/i.test(v.t) ? v.t + ' · ' : '';
    return vt + money(v.p) + ' each';
  }
  function unitLabel(p) {
    if (p.bulk) return '<b>' + money(p.v100.p) + '</b> / 100 g';
    if (p.v.length > 1) {
      var lo = Math.min.apply(null, p.v.map(function (v) { return v.p; }));
      return 'from <b>' + money(lo) + '</b>';
    }
    return '<b>' + money(p.v[0].p) + '</b>';
  }
  function subtotal() { return S.items.reduce(function (a, it) { return a + price(it); }, 0); }
  function findItem(h, vid) { for (var i = 0; i < S.items.length; i++) { var it = S.items[i]; if (it.h === h && (!vid || it.vid === vid)) return it; } return null; }

  /* ---------- loading ---------- */
  function fetchPage(n) {
    return fetch(cfg.feed + '&page=' + n, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('feed ' + r.status); return r.json(); });
  }
  function load() {
    var cached = sstore(CACHE);
    if (cached) {
      try { var c = JSON.parse(cached); if (Date.now() - c.t < 20 * 60 * 1000) return Promise.resolve(c.p); } catch (e) {}
    }
    return fetchPage(1).then(function (first) {
      var rest = [];
      for (var i = 2; i <= (first.pages || 1); i++) rest.push(fetchPage(i));
      return Promise.all(rest).then(function (pages) {
        var all = first.products.slice();
        pages.forEach(function (pg) { all = all.concat(pg.products); });
        sstore(CACHE, JSON.stringify({ t: Date.now(), p: all }));
        return all;
      });
    });
  }

  /* ---------- starter boxes (parsed from the ready box descriptions) ---------- */
  var WORDS = { one: 1, a: 1, an: 1, two: 2, three: 3, four: 4, five: 5, six: 6 };
  function parseStarter(st) {
    var doc = new DOMParser().parseFromString(st.html || '', 'text/html');
    var out = [];
    $$('li', doc).forEach(function (li) {
      var a = li.querySelector('a[href*="/products/"]');
      if (!a) return;
      var h = (a.getAttribute('href').split('/products/')[1] || '').split(/[?#]/)[0];
      if (!h || h === 'scoop-red-gift-box') return;
      var code = li.querySelector('span span');
      var text = li.textContent.replace(code ? code.textContent : '', ' ');
      var m = text.match(/(\d+(?:\.\d+)?)\s*(kg|g|ml)\b/i);
      var lead = norm(text.trim().split(/\s+/)[0]);
      out.push({ h: h, g: m ? (m[2].toLowerCase() === 'kg' ? +m[1] * 1000 : +m[1]) : 0, unit: m ? m[2].toLowerCase() : '', n: WORDS[lead] || 1 });
    });
    return out;
  }
  function itemsFromStarter(st) {
    var items = [];
    parseStarter(st).forEach(function (x) {
      var p = S.by[x.h]; if (!p) return;
      if (p.bulk) { items.push({ h: p.h, amt: Math.max(100, Math.round((x.g || 100) / 100) * 100) }); return; }
      var v = p.v[0];
      if (x.g && p.v.length > 1) {
        var tok = String(x.g >= 1000 && x.unit === 'kg' ? x.g / 1000 : x.g);
        p.v.forEach(function (vv) { if (norm(vv.t).replace(/\s/g, '').indexOf(tok) > -1) v = vv; });
      }
      items.push({ h: p.h, vid: v.id, amt: x.n });
    });
    return items;
  }

  /* ---------- share / draft ---------- */
  function encodeBox() {
    var o = { n: $('[data-sbb-name]').value, i: S.items.map(function (it) { var p = S.by[it.h]; var v = it.vid ? variant(p, it.vid) : null; return [it.h, it.amt, v ? v.t : 0]; }) };
    return btoa(unescape(encodeURIComponent(JSON.stringify(o)))).replace(/=+$/, '');
  }
  function decodeBox(s) {
    try {
      var o = JSON.parse(decodeURIComponent(escape(atob(s))));
      var items = [];
      (o.i || []).forEach(function (r) {
        var p = S.by[r[0]]; if (!p) return;
        if (p.bulk) items.push({ h: p.h, amt: Math.max(100, +r[1] || 100) });
        else {
          var v = p.v[0]; if (r[2]) p.v.forEach(function (vv) { if (vv.t === r[2]) v = vv; });
          items.push({ h: p.h, vid: v.id, amt: Math.max(1, +r[1] || 1) });
        }
      });
      return { n: o.n || '', items: items };
    } catch (e) { return null; }
  }
  function saveDraft() {
    if (!S.ready) return;
    if (!S.items.length) { store(KEY, null); return; }
    store(KEY, JSON.stringify({ b: encodeBox(), to: $('[data-sbb-to]').value, m: $('[data-sbb-msg]').value, x: S.boxes, t: Date.now() }));
  }

  /* ---------- the box drawing ---------- */
  var GIFT_W = 300;
  function boxSVG(items, opts) {
    opts = opts || {};
    var W = GIFT_W, id = opts.id || 'm';
    var shown = items.slice(0, 15), extra = items.length - shown.length;
    var cols = 5, r = 21, x0 = 62, dx = 44, rows = [104, 80, 56];
    var circles = shown.map(function (it, i) {
      var p = S.by[it.h] || {};
      var row = Math.floor(i / cols), col = i % cols;
      var cx = x0 + col * dx + (row % 2 ? 8 : -4);
      var cy = rows[row] || 56;
      var cls = (!opts.still && S.lastAdded && S.lastAdded === itemKey(it)) ? ' class="sbb-pop"' : '';
      var img = p.img ? '<image href="' + esc(p.img) + '" x="' + (cx - r) + '" y="' + (cy - r) + '" width="' + (2 * r) + '" height="' + (2 * r) + '" preserveAspectRatio="xMidYMid slice" clip-path="url(#c' + id + i + ')"/>'
        : '<text x="' + cx + '" y="' + (cy + 5) + '" text-anchor="middle" font-size="13" font-weight="700" fill="#B1882F">' + esc(initials(p.n)) + '</text>';
      return '<g' + cls + '><clipPath id="c' + id + i + '"><circle cx="' + cx + '" cy="' + cy + '" r="' + r + '"/></clipPath>' +
        '<circle cx="' + cx + '" cy="' + cy + '" r="' + (r + 2.5) + '" fill="#fff" stroke="#E8DBC1"/>' + img + '</g>';
    }).reverse().join('');
    if (opts.closed) { circles = ''; extra = 0; }
    var empty = !items.length && !opts.closed ? '<text x="150" y="78" text-anchor="middle" font-size="13" fill="#8A7A70" font-style="italic">Your box is waiting</text>' +
      '<path d="M150 88v14m-6-6 6 6 6-6" stroke="#B1882F" fill="none" stroke-width="1.4" stroke-linecap="round"/>' : '';
    var more = extra > 0 ? '<g><circle cx="262" cy="136" r="17" fill="#D9B45A"/><text x="262" y="141" text-anchor="middle" font-size="13" font-weight="700" fill="#1F1410">+' + extra + '</text></g>' : '';
    var lid = opts.lid ? '<g class="sbb-lid"><path d="M22 96h256v24H22z" fill="#6E2029"/><path d="M22 96h256" stroke="#8C2E3A" stroke-width="2"/>' +
      '<rect x="22" y="116" width="256" height="4" fill="rgba(0,0,0,.18)"/></g>' : '';
    var ribbon = opts.ribbon ? '<path class="sbb-rib sbb-rib--v" d="M78 96V248" stroke="#F4EBDD" stroke-width="16"/>' +
      '<path class="sbb-rib sbb-rib--h" d="M22 226H278" stroke="#F4EBDD" stroke-width="13"/>' +
      '<g class="sbb-bow"><path d="M78 96c-10-22-46-30-46-10 0 16 30 14 46 10zM78 96c10-22 46-30 46-10 0 16-30 14-46 10z" fill="#F4EBDD" stroke="#E2D3BC" stroke-width="1.5"/>' +
      '<path d="M74 98l-14 30M82 98l14 30" stroke="#F4EBDD" stroke-width="7" stroke-linecap="round"/><circle cx="78" cy="96" r="7" fill="#EADBC4"/></g>' : '';
    var tag = opts.tag ? '<g class="sbb-tag"><path d="M214 132l56-8 5 30-56 8z" fill="#FBF8F3" stroke="#B1882F"/><circle cx="221" cy="139" r="2.5" fill="#B1882F"/>' +
      '<text x="246" y="149" text-anchor="middle" font-size="8.5" fill="#7F2631" font-style="italic" transform="rotate(-8 246 146)">' + esc((opts.tag || '').slice(0, 16)) + '</text></g>' : '';
    return '<svg viewBox="0 -10 ' + W + ' 270" role="img" aria-label="Your red Scoop gift box with ' + items.length + ' items">' +
      '<ellipse cx="150" cy="250" rx="130" ry="9" fill="rgba(31,20,16,.12)"/>' +
      '<path d="M30 114l14-20h212l14 20z" fill="#4A141B"/>' + empty + circles +
      '<path d="M30 114h240v128a6 6 0 0 1-6 6H36a6 6 0 0 1-6-6z" fill="#7F2631"/>' +
      '<path d="M30 114h240" stroke="#9A3542" stroke-width="2"/>' +
      '<path d="M30 114h240v14H30z" fill="rgba(0,0,0,.12)"/>' +
      '<text x="150" y="186" text-anchor="middle" font-size="30" font-weight="700" letter-spacing="3" fill="#D9B45A" style="font-family:Georgia,serif">SCOOP</text>' +
      '<text x="150" y="204" text-anchor="middle" font-size="9" letter-spacing="4.5" fill="#D9B45A">WHOLEFOODS</text>' +
      more + lid + ribbon + tag + '</svg>';
  }

  /* ---------- render: catalogue ---------- */
  function filtered() {
    var q = norm(S.q).trim(), words = q ? q.split(/\s+/) : [];
    var list = S.products.filter(function (p) {
      if (S.type && p.ty !== S.type) return false;
      if (S.diet && (p.d || []).indexOf(S.diet) < 0) return false;
      if (S.fav && !S.favs[p.h]) return false;
      for (var i = 0; i < words.length; i++) if (p.s.indexOf(words[i]) < 0) return false;
      return true;
    });
    if (!q && !S.type && !S.diet) list.sort(function (a, b) { return (S.favs[b.h] ? 1 : 0) - (S.favs[a.h] ? 1 : 0); });
    return list;
  }
  function cardAct(p) {
    var it = p.bulk ? findItem(p.h) : null;
    if (p.bulk) {
      if (it) return stepper(p.h, '', fmtG(it.amt), 'sbb-step');
      return '<button type="button" class="sbb-add" data-add="' + esc(p.h) + '">Add 100 g</button>';
    }
    var sel = '';
    if (p.v.length > 1) sel = '<select data-var="' + esc(p.h) + '" aria-label="Choose a size">' + p.v.map(function (v) { return '<option value="' + v.id + '"' + (v.id === (+(S.sel && S.sel[p.h]) || p.v[0].id) ? ' selected' : '') + '>' + esc(v.t) + ' · ' + money(v.p) + '</option>'; }).join('') + '</select>';
    var cur = p.v.length > 1 ? (+(S.sel && S.sel[p.h]) || p.v[0].id) : p.v[0].id;
    it = findItem(p.h, cur);
    if (it) return sel + stepper(p.h, cur, it.amt + ' in box', 'sbb-step');
    return sel + '<button type="button" class="sbb-add" data-add="' + esc(p.h) + '">Add to box</button>';
  }
  function stepper(h, vid, label, cls) {
    return '<div class="' + cls + '"><button type="button" data-dec="' + esc(h) + '" data-vid="' + (vid || '') + '" aria-label="Less">−</button><output>' + esc(label) + '</output>' +
      '<button type="button" data-inc="' + esc(h) + '" data-vid="' + (vid || '') + '" aria-label="More">+</button></div>';
  }
  function cardHTML(p) {
    var inBox = S.items.some(function (it) { return it.h === p.h; });
    return '<article class="sbb-card' + (inBox ? ' is-in' : '') + '" data-h="' + esc(p.h) + '">' +
      '<span class="sbb-card__tick" aria-hidden="true">✓</span>' +
      '<div class="sbb-card__img">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy" width="300" height="300">' : '<b>' + esc(initials(p.n)) + '</b>') + '</div>' +
      '<h3>' + esc(p.n) + '</h3><p class="sbb-card__m">' + unitLabel(p) + (p.c ? ' · Bin ' + esc(p.c) : '') + '</p>' +
      '<div class="sbb-card__act">' + cardAct(p) + '</div></article>';
  }
  function renderGrid() {
    var list = filtered(), grid = $('[data-sbb-grid]');
    var n = list.length;
    $('[data-sbb-count]').textContent = n ? n + (n === 1 ? ' product' : ' products') + (S.q || S.type || S.diet || S.fav ? ' match' : ' you can put in the box') : '';
    if (!n) { grid.innerHTML = '<p class="sbb-empty">Nothing matches that. Try another word, or clear the filters.</p>'; $('[data-sbb-more]').hidden = true; return; }
    grid.innerHTML = list.slice(0, S.shown).map(cardHTML).join('');
    $('[data-sbb-more]').hidden = n <= S.shown;
  }
  function refreshCard(h) {
    var el = $('.sbb-card[data-h="' + (window.CSS && CSS.escape ? CSS.escape(h) : h) + '"]');
    if (!el) return;
    var sel = el.querySelector('select'), cur = sel ? sel.value : null;
    el.outerHTML = cardHTML(S.by[h]);
    if (cur) { var ns = $('.sbb-card[data-h="' + (window.CSS && CSS.escape ? CSS.escape(h) : h) + '"] select'); if (ns) ns.value = cur; }
  }
  function renderFilters() {
    var types = {}, diets = {};
    S.products.forEach(function (p) {
      if (p.ty) types[p.ty] = (types[p.ty] || 0) + 1;
      (p.d || []).forEach(function (d) { diets[d] = (diets[d] || 0) + 1; });
    });
    var sel = $('[data-sbb-type]');
    Object.keys(types).sort().forEach(function (t) { var o = document.createElement('option'); o.value = t; o.textContent = t + ' (' + types[t] + ')'; sel.appendChild(o); });
    var chips = '<button type="button" class="sbb-chip sbb-chip--fav" data-fav aria-pressed="false">Gift favourites</button>';
    ['Vegan', 'Gluten Free', 'Dairy Free', 'Nut Free', 'No Added Sugar', 'Organic'].filter(function (d) { return diets[d] >= 5; }).forEach(function (d) {
      chips += '<button type="button" class="sbb-chip" data-diet="' + esc(d) + '" aria-pressed="false">' + esc(d) + '</button>';
    });
    $('[data-sbb-chips]').innerHTML = chips;
  }

  /* ---------- render: the box ---------- */
  function insideHTML() {
    var withDiet = S.items.every(function (it) { var d = S.by[it.h].d; return d && d.length; });
    var common = null;
    if (withDiet) S.items.forEach(function (it) { var d = S.by[it.h].d; common = common ? common.filter(function (x) { return d.indexOf(x) > -1; }) : d.slice(); });
    common = (common || []).filter(function (d) { return !(d === 'Vegetarian' && common.indexOf('Vegan') > -1); });
    var alls = [];
    S.items.forEach(function (it) { var p = S.by[it.h]; if (p.a) alls.push('<li><b>' + esc(p.n) + ':</b> ' + esc(p.a) + '</li>'); });
    var html = '<h4>What is inside</h4>';
    html += common.length ? '<p>Everything in this box is:</p><div class="sbb-diet">' + common.map(function (d) { return '<span>' + esc(d) + '</span>'; }).join('') + '</div>' : '';
    html += alls.length ? '<p>Allergens from our labels:</p><ul>' + alls.join('') + '</ul>' : '<p>No allergens listed on our labels for these items.</p>';
    html += '<small>Taken from our product labels. If someone has a serious allergy, check each pack or ask us before you order.</small>';
    return html;
  }
  function renderBox() {
    var sub = subtotal(), done = sub >= cfg.min, n = S.items.length;
    $('[data-sbb-stage]').innerHTML = boxSVG(S.items);
    $('[data-sbb-bar]').style.width = Math.min(100, sub / cfg.min * 100) + '%';
    $('.sbb-progress').classList.toggle('is-done', done);
    $('[data-sbb-progress-t]').textContent = !n ? 'Add at least $' + (cfg.min / 100) + ' of items to your box.' :
      done ? 'Minimum reached. You can go to the next step.' : 'Add ' + money(cfg.min - sub) + ' more to reach the $' + (cfg.min / 100) + ' minimum.';
    $('[data-sbb-items]').innerHTML = S.items.map(function (it) {
      var p = S.by[it.h];
      return '<li class="sbb-item">' + (p.img ? '<img src="' + esc(p.img) + '" alt="">' : '<i></i>') +
        '<div><p class="sbb-item__n">' + esc(p.n) + '</p><p class="sbb-item__p">' + esc(amtLabel(it)) + '</p>' +
        stepper(it.h, it.vid || '', p.bulk ? fmtG(it.amt) : String(it.amt), 'sbb-step sbb-step--sm') + '</div>' +
        '<div class="sbb-item__r">' + money(price(it)) + '<br><button type="button" class="sbb-item__x" data-rm="' + esc(it.h) + '" data-vid="' + (it.vid || '') + '">Remove</button></div></li>';
    }).join('');
    var ins = $('[data-sbb-inside]');
    if (n) { ins.innerHTML = insideHTML(); ins.hidden = false; } else ins.hidden = true;
    $('[data-sbb-sub]').textContent = money(sub);
    $('[data-sbb-next2]').disabled = !done;
    $('[data-sbb-bar-n]').textContent = n;
    $('[data-sbb-bar-t]').textContent = n ? n + (n === 1 ? ' item · ' : ' items · ') + money(sub) : 'Your box is empty';
    $('[data-sbb-bar-s]').textContent = done ? 'Ready for the next step' : 'Add ' + money(Math.max(0, cfg.min - sub)) + ' to reach $' + (cfg.min / 100);
    var cta = $('[data-sbb-bar-cta]');
    cta.textContent = done ? 'Next step →' : 'View box';
    cta.classList.toggle('is-next', done);
    wizState();
    S.lastAdded = null;
    saveDraft();
  }
  function renderCard() {
    var to = $('[data-sbb-to]').value.trim(), msg = $('[data-sbb-msg]').value.trim();
    $('[data-sbb-prev-to]').textContent = to ? 'For ' + to : 'For you';
    var m = $('[data-sbb-prev-msg]');
    m.textContent = msg || 'Your message appears here, the way we will write it.';
    m.classList.toggle('is-ph', !msg);
    $('[data-sbb-msgc]').textContent = $('[data-sbb-msg]').value.length + ' / 300';
  }
  function renderReviewArt() {
    var name = $('[data-sbb-name]').value.trim() || 'My Scoop box', to = $('[data-sbb-to]').value.trim();
    $('[data-sbb-review-art]').innerHTML = boxSVG([], { id: 'r', lid: true, ribbon: true, closed: true, tag: to ? 'For ' + to : name, still: true });
  }
  function renderReview() {
    var sub = subtotal(), per = sub + cfg.giftPrice, total = per * S.boxes;
    var name = $('[data-sbb-name]').value.trim() || 'My Scoop box';
    var to = $('[data-sbb-to]').value.trim(), msg = $('[data-sbb-msg]').value.trim();
    $('[data-sbb-review-name]').textContent = name;
    var rc = $('[data-sbb-review-card]');
    rc.hidden = !msg;
    $('[data-sbb-review-to]').textContent = to ? 'For ' + to : '';
    $('[data-sbb-review-msg]').textContent = msg;
    $('[data-sbb-rlist]').innerHTML = S.items.map(function (it) {
      var p = S.by[it.h], v = p.bulk ? null : variant(p, it.vid);
      var amt = p.bulk ? fmtG(it.amt) : it.amt + (v && !/default title/i.test(v.t) ? ' × ' + v.t : ' ×');
      return '<li>' + (p.img ? '<img src="' + esc(p.img) + '" alt="">' : '<i></i>') + '<span class="sbb-rlist__n">' + esc(p.n) + '<small>' + esc(amt) + '</small></span><b>' + money(price(it)) + '</b></li>';
    }).join('') + '<li class="sbb-rlist__gift"><i></i><span class="sbb-rlist__n">Red gift box and ribbon<small>Card written by hand' + (msg ? '' : ' (no card)') + '</small></span><b>' + money(cfg.giftPrice) + '</b></li>';
    var ins = $('[data-sbb-inside4]'); ins.innerHTML = insideHTML(); ins.hidden = !S.items.length;
    $('[data-sbb-sub4]').textContent = money(sub);
    $('[data-sbb-gift]').textContent = money(cfg.giftPrice);
    $('[data-sbb-per]').textContent = money(per);
    $('[data-sbb-total-l]').textContent = S.boxes > 1 ? 'Total for ' + S.boxes + ' boxes' : 'Total';
    $('[data-sbb-total]').textContent = money(total);
    $('[data-sbb-boxes-v]').textContent = S.boxes;
    $('[data-sbb-lead]').hidden = S.boxes < 10;
    $('[data-sbb-pack]').textContent = S.boxes > 1 ? 'Pack my ' + S.boxes + ' boxes · ' + money(total) : 'Pack my box · ' + money(total);
  }

  /* ---------- steps ---------- */
  S.step = 1; S.started = false;
  function canGo(n) {
    if (n <= 1) return true;
    if (n === 2) return S.started;
    return S.started && subtotal() >= cfg.min;
  }
  function wizState() {
    $$('[data-sbb-wiz] [data-go]').forEach(function (b) {
      var n = +b.dataset.go;
      b.classList.toggle('is-on', n === S.step);
      b.classList.toggle('is-done', n < S.step);
      b.disabled = !canGo(n);
      if (n === S.step) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
    });
  }
  function go(n, opts) {
    opts = opts || {};
    if (!canGo(n)) {
      if (n >= 3 && S.started) toast('Add ' + money(cfg.min - subtotal()) + ' more to your box first.');
      return;
    }
    S.step = n;
    root.dataset.step = n;
    $$('[data-pane]').forEach(function (p) { p.hidden = +p.dataset.pane !== n; });
    openPanel(false);
    if (n === 2) { renderGrid(); renderBox(); }
    if (n === 3) renderCard();
    if (n === 4) { renderReviewArt(); renderReview(); }
    wizState();
    if (!opts.noHistory) { try { history.pushState({ sbb: n }, '', location.pathname + location.search + location.hash); } catch (e) {} }
    if (!opts.noScroll) {
      var hdr = document.querySelector('.shopify-section-header-sticky, sticky-header, .section-header'), hh = 0;
      if (hdr) { var ps = getComputedStyle(hdr).position; if (ps === 'sticky' || ps === 'fixed' || hdr.classList.contains('shopify-section-header-sticky')) hh = hdr.offsetHeight; }
      var top = $('[data-sbb-wiz]').getBoundingClientRect().top + window.pageYOffset - hh - 16;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }
  }
  window.addEventListener('popstate', function (e) {
    var n = e.state && e.state.sbb;
    if (n) go(n, { noHistory: true });
    else if (S.step !== 1) go(1, { noHistory: true });
  });
  try { history.replaceState({ sbb: 1 }, ''); } catch (e) {}

  /* ---------- actions ---------- */
  function add(h, vid) {
    var p = S.by[h]; if (!p) return;
    var it, was = subtotal();
    if (p.bulk) { it = findItem(h); if (it) it.amt += 100; else { it = { h: h, amt: 100 }; S.items.push(it); } }
    else { vid = vid || p.v[0].id; it = findItem(h, vid); if (it) it.amt += 1; else { it = { h: h, vid: vid, amt: 1 }; S.items.push(it); } }
    S.lastAdded = itemKey(it);
    bump();
    renderBox(); refreshCard(h);
    if (was < cfg.min && subtotal() >= cfg.min) toast('Minimum reached. Keep adding, or go to step 3 when you are ready.');
  }
  function dec(h, vid) {
    var p = S.by[h], it = findItem(h, p.bulk ? null : vid); if (!it) return;
    it.amt -= p.bulk ? 100 : 1;
    if (it.amt <= 0) S.items.splice(S.items.indexOf(it), 1);
    renderBox(); refreshCard(h);
  }
  function rm(h, vid) {
    var p = S.by[h], it = findItem(h, p.bulk ? null : vid); if (!it) return;
    S.items.splice(S.items.indexOf(it), 1);
    renderBox(); refreshCard(h);
  }
  function bump() { var b = $('.sbb-bar__box'); if (!b) return; b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump'); }

  function startBuild(items, name, fromLabel) {
    S.items = items || [];
    S.started = true;
    if (name != null) $('[data-sbb-name]').value = name;
    go(2);
    if (fromLabel) toast(fromLabel);
  }

  function openPanel(on) {
    $('[data-sbb-panel]').classList.toggle('is-open', on);
    document.body.classList.toggle('sbb-lock', on && window.matchMedia('(max-width:989px)').matches);
  }

  function pack() {
    var sub = subtotal(), err = $('[data-sbb-err]');
    err.hidden = true;
    if (sub < cfg.min) { go(2); return; }
    var name = $('[data-sbb-name]').value.trim() || 'My Scoop box';
    var to = $('[data-sbb-to]').value.trim(), msg = $('[data-sbb-msg]').value.trim();
    var ref = Math.random().toString(36).slice(2, 7).toUpperCase();
    var n = S.boxes, lines = [];
    S.items.forEach(function (it) {
      var p = S.by[it.h], props = { 'Box': name, 'Per box': p.bulk ? fmtG(it.amt) : String(it.amt), '_box': ref };
      if (p.bulk) {
        var kg = p.vkg ? Math.floor(it.amt / 1000) : 0, rest = Math.round((it.amt - kg * 1000) / 100);
        if (kg) lines.push({ id: p.vkg.id, quantity: kg * n, properties: props });
        if (rest) lines.push({ id: p.v100.id, quantity: rest * n, properties: props });
      } else lines.push({ id: it.vid, quantity: it.amt * n, properties: props });
    });
    var gp = { 'Box': name, '_box': ref };
    if (to) gp['To'] = to;
    if (msg) gp['Card message'] = msg;
    if (n > 1) gp['Boxes'] = String(n);
    lines.push({ id: cfg.giftId, quantity: n, properties: gp });

    var ov = $('[data-sbb-packing]');
    $('[data-sbb-packing-art]').innerHTML = boxSVG([], { id: 'p', lid: true, ribbon: true, closed: true, tag: to ? 'For ' + to : name, still: true });
    $('[data-sbb-packing-t]').textContent = n > 1 ? 'Packing your ' + n + ' boxes' : 'Packing your box';
    ov.hidden = false;
    var anim = new Promise(function (r) { setTimeout(r, 2600); });
    var req = fetch(cfg.cartAdd, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: lines }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong'); return j; }); });
    Promise.all([req, anim]).then(function () {
      $('[data-sbb-packing-t]').textContent = 'Packed. Taking you to your cart.';
      store(KEY, null);
      setTimeout(function () { window.location.href = cfg.cart; }, 700);
    }).catch(function (e) {
      ov.hidden = true;
      err.textContent = 'We could not add the box to your cart: ' + e.message + '. Please try again or call us.';
      err.hidden = false;
    });
  }

  function share() {
    var url = location.origin + location.pathname + '#b=' + encodeBox();
    var done = function () { toast('Link copied. Send it to anyone to open this box.'); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, function () { fallbackCopy(url); done(); });
    else { fallbackCopy(url); done(); }
    try { history.replaceState(history.state, '', url); } catch (e) {}
  }
  function fallbackCopy(t) { var a = document.createElement('textarea'); a.value = t; a.style.position = 'fixed'; a.style.opacity = '0'; document.body.appendChild(a); a.select(); try { document.execCommand('copy'); } catch (e) {} a.remove(); }

  /* ---------- events ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target.closest('button'); if (!t || !root.contains(t)) return;
    var d = t.dataset;
    if (d.go) { go(+d.go); return; }
    if (d.add) { var card = t.closest('.sbb-card'), sel = card && card.querySelector('select'); add(d.add, sel ? +sel.value : null); return; }
    if (d.inc) { add(d.inc, +d.vid || null); return; }
    if (d.dec) { dec(d.dec, +d.vid || null); return; }
    if (d.rm) { rm(d.rm, +d.vid || null); return; }
    if (d.sbbBoxes) { S.boxes = Math.max(1, Math.min(99, S.boxes + (+d.sbbBoxes))); renderReview(); saveDraft(); return; }
    if ('fav' in d) { S.fav = !S.fav; t.setAttribute('aria-pressed', S.fav); S.shown = PAGE; renderGrid(); return; }
    if (d.diet) { S.diet = S.diet === d.diet ? '' : d.diet; $$('[data-diet]').forEach(function (c) { c.setAttribute('aria-pressed', c.dataset.diet === S.diet); }); S.shown = PAGE; renderGrid(); return; }
    if ('sbbMore' in d) { S.shown += PAGE; renderGrid(); return; }
    if ('sbbEmpty' in d) { whenReady(function () { startBuild([], null, 'Your empty box is ready. Tap Add on anything you like.'); }); return; }
    if (d.st != null) { var st = starters[+d.st]; whenReady(function () { startBuild(itemsFromStarter(st), st.n.replace(/ Box$/i, '') + ' box, my way', st.n + ' is in your box. Change anything.'); }); return; }
    if ('sbbBarOpen' in d) { openPanel(true); return; }
    if ('sbbBarCta' in d) { if (subtotal() >= cfg.min) go(3); else openPanel(true); return; }
    if ('sbbClose' in d) { openPanel(false); return; }
    if ('sbbPack' in d) { pack(); return; }
    if ('sbbShare' in d) { share(); return; }
    if ('resume' in d) { resume(); return; }
  });
  root.addEventListener('change', function (e) {
    if (e.target.matches('[data-var]')) { S.sel = S.sel || {}; S.sel[e.target.dataset.var] = +e.target.value; refreshCard(e.target.dataset.var); }
    if (e.target.matches('[data-sbb-type]')) { S.type = e.target.value; S.shown = PAGE; renderGrid(); }
  });
  var qT;
  root.addEventListener('input', function (e) {
    if (e.target.matches('[data-sbb-q]')) { clearTimeout(qT); qT = setTimeout(function () { S.q = e.target.value; S.shown = PAGE; renderGrid(); }, 160); }
    if (e.target.matches('[data-sbb-name],[data-sbb-to],[data-sbb-msg]')) { renderCard(); saveDraft(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') openPanel(false); });

  /* ---------- resume / init ---------- */
  var pendingDraft = null, queued = null;
  function whenReady(fn) {
    if (S.ready) return fn();
    queued = fn;
    toast('One moment, loading the shelves…');
  }
  function resume() {
    if (!pendingDraft) return;
    var box = decodeBox(pendingDraft.b); if (!box) return;
    $('[data-sbb-to]').value = pendingDraft.to || '';
    $('[data-sbb-msg]').value = pendingDraft.m || '';
    S.boxes = Math.max(1, +pendingDraft.x || 1);
    startBuild(box.items, box.n, 'Welcome back. Your box is as you left it.');
  }

  function renderStarters() {
    if (!$('[data-sbb-starters]')) return;
    $('[data-sbb-starters]').innerHTML = starters.map(function (st, i) {
      return '<button type="button" class="sbb-st" data-st="' + i + '"><img src="' + esc(st.img) + '" alt="" loading="lazy"><span>' + esc(st.n) + '</span></button>';
    }).join('');
  }

  renderStarters();
  wizState();
  load().then(function (list) {
    S.products = list.map(prep).filter(function (p) { return p.v.length; });
    S.products.forEach(function (p) { S.by[p.h] = p; });
    starters.forEach(function (st) { parseStarter(st).forEach(function (x) { S.favs[x.h] = 1; }); });
    S.ready = true;
    renderFilters();
    if (queued) { var q = queued; queued = null; q(); return; }
    var m = location.hash.match(/[#&]b=([^&]+)/);
    if (m) { var box = decodeBox(m[1]); if (box && box.items.length) { startBuild(box.items, box.n, 'This box was shared with you. Change anything you like.'); return; } }
    var raw = store(KEY);
    if (raw) {
      try { pendingDraft = JSON.parse(raw); } catch (e) { pendingDraft = null; }
      if (pendingDraft && Date.now() - pendingDraft.t < 30 * 864e5) {
        var r = $('[data-sbb-resume]');
        r.innerHTML = 'You have a box in progress. <button type="button" data-resume>Carry on with it</button>';
        r.hidden = false;
      }
    }
  }).catch(function () {
    $('[data-sbb-count]').textContent = 'The shelves did not load. Please refresh the page.';
    toast('The shelves did not load. Please refresh the page.');
  });
})();
